const HomeModule: Object = {
  state: {
    loginRegisterDialogShow: true,
    isLoggedIn: sessionStorage.getItem('isLoggedIn') === 'true' // 从 sessionStorage 中获取登录状态
  },
  mutations: {
    SET_LOGIN_REGISTER(state: any) {
      state.loginRegisterDialogShow = !state.loginRegisterDialogShow
    },
    // 新增：设置登录状态
    SET_LOGIN_STATUS(state: any, status: boolean) {
      state.isLoggedIn = status
      sessionStorage.setItem('isLoggedIn', status.toString()) // 将登录状态存储到 sessionStorage
    }
  },
  actions: {

  },
  getters: {

  }
}

export default HomeModule